"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppInsightsProvider = void 0;
var _applicationinsightsReactJs = require("@microsoft/applicationinsights-react-js");
var _react = require("react");
var _applicationInsights = require("../application-insights");
var _jsxRuntime = require("react/jsx-runtime");
const AppInsightsProvider = ({
  children
}) => {
  const [appInsights, setAppInsights] = (0, _react.useState)({
    reactPlugin: new _applicationinsightsReactJs.ReactPlugin()
  });
  (0, _react.useEffect)(() => {
    if (_applicationInsights.ApplicationInsights.isInitialized()) {
      setAppInsights({
        reactPlugin: (0, _applicationInsights.getApplicationInsightsReactPlugin)()
      });
    } else {
      // This could happen and we want to cover this case
      const {
        remove: removeListener
      } = _applicationInsights.ApplicationInsights.onInitialized(() => {
        setAppInsights({
          reactPlugin: (0, _applicationInsights.getApplicationInsightsReactPlugin)()
        });
      });
      return () => {
        removeListener();
      };
    }
    return () => {};
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_applicationinsightsReactJs.AppInsightsContext.Provider, {
    value: appInsights.reactPlugin,
    children: children
  });
};
exports.AppInsightsProvider = AppInsightsProvider;
//# sourceMappingURL=AppInsightsProvider.js.map